<div class="container">
  <div class="col-lg-12 holder">
    <div class="search-bar">
      <input
        type="text"
        width="100"
        class="form-control session-ideas-search"
        [(ngModel)]="search"
        placeholder="Search by name or organization ..." />
    </div>
    <br />

    <participant-bar-control [sorting]="sorting"></participant-bar-control>
    <participant-bar
      *ngFor="let entry of sortedEntries; trackBy: trackById"
      [entry]="entry"
      [session]="session"
      (unInvite)="uninvite($event)"
      (openIdea)="openIdea.emit($event)"></participant-bar>

    <br />
    <!--
    <ng-container *ngIf="moderators.length + moderatorInvites.length > 0">
      <h3>Moderators</h3>

      <div class="users">
        <div class="user" *ngFor="let user of moderators; last as last" [ngClass]="{'last': last}">
          <div class="info">
            <profile-picture [user]="user"></profile-picture>
            <name-tag [user]="user" [link]="true"></name-tag>
          </div>
          <a class="btn btn-primary d-xs-none d-md-block" href="/profile/{{user._id}}" target="_blank">Profile</a>
          <button class="btn btn-primary d-xs-none d-md-block" (click)="directMsg(user)">Send a Message</button>
          <button class="btn btn-primary d-md-none" (click)="directMsg(user)">
            <i class="icon-send-msg"></i>
          </button>
        </div>
      </div>

      <div class="invites" *ngIf="canInvite">
        <ng-container *ngFor="let invite of moderatorInvites">
          <div class="user invite">
            <div class="info">
              <img src="/assets/images/verify-email.svg"/>
              {{invite.first_name}} {{invite.name}}
              <ng-container *ngIf="isCreator(invite) || invite.organization">
              (<ng-container *ngIf="invite.organization">{{invite.organization}}</ng-container>
                <ng-container *ngIf="invite.organization && isCreator(invite)">, </ng-container>
                <ng-container *ngIf="isCreator(invite)">{{invite.email}}</ng-container>)
              </ng-container>
            </div>
            <button *ngIf="canUninvite(invite)" (click)="uninvite(invite)" class="btn btn-danger">
              Revoke Invitation
            </button>
            <small *ngIf="!canUninvite(invite)">
              You can't revoke this invitation, because someone invited this person with a stronger role.
            </small>
          </div>
        </ng-container>
      </div>

      <br/>
    </ng-container>

    <ng-container *ngIf="participants.length + participantInvites.length > 0">
      <h3>Participants</h3>

      <div class="users">
        <div class="user" *ngFor="let user of participants; last as last" [ngClass]="{'last': last}">
          <div class="info">
            <profile-picture [user]="user"></profile-picture>
            <name-tag [user]="user" [link]="true"></name-tag>
          </div>
          <a class="btn btn-primary d-xs-none d-md-block" href="/profile/{{user._id}}" target="_blank">Profile</a>
          <button class="btn btn-primary d-xs-none d-md-block" (click)="directMsg(user)">Send a Message</button>
          <button class="btn btn-primary d-md-none" (click)="directMsg(user)">
            <i class="icon-send-msg"></i>
          </button>
        </div>
      </div>

      <div class="invites" *ngIf="canInvite">
        <ng-container *ngFor="let invite of participantInvites">
          <div class="user invite">
            <div class="info">
              <img src="/assets/images/verify-email.svg"/>
              {{invite.first_name}} {{invite.name}}
              <ng-container *ngIf="isCreator(invite) || invite.organization">
              (<ng-container *ngIf="invite.organization">{{invite.organization}}</ng-container>
                <ng-container *ngIf="invite.organization && isCreator(invite)">, </ng-container>
                <ng-container *ngIf="isCreator(invite)">{{invite.email}}</ng-container>)
              </ng-container>
            </div>
            <button *ngIf="canUninvite(invite)" (click)="uninvite(invite)" class="btn btn-danger">
              Revoke Invitation
            </button>
            <small *ngIf="!canUninvite(invite)">
              You can't revoke this invitation, because someone invited this person with a stronger role.
            </small>
          </div>
        </ng-container>
      </div>

      <br/>
    </ng-container>

    <ng-container *ngIf="externals.length + evaluatorInvites.length > 0">
      <h3>External Evaluators</h3>

      <div class="users">
        <div class="user" *ngFor="let user of externals; last as last" [ngClass]="{'last': last}">
          <div class="info">
            <profile-picture [user]="user"></profile-picture>
            <name-tag [user]="user" [link]="true"></name-tag>
          </div>
          <a class="btn btn-primary d-xs-none d-md-block" href="/profile/{{user._id}}" target="_blank">Profile</a>
          <button class="btn btn-primary d-xs-none d-md-block" (click)="directMsg(user)">Send a Message</button>
          <button class="btn btn-primary d-md-none" (click)="directMsg(user)">
            <i class="icon-send-msg"></i>
          </button>
        </div>
      </div>

      <div class="invites" *ngIf="canInvite">
        <ng-container *ngFor="let invite of evaluatorInvites">
          <div class="user invite">
            <div class="info">
              <img src="/assets/images/verify-email.svg"/>
              {{invite.first_name}} {{invite.name}}
              <ng-container *ngIf="isCreator(invite) || invite.organization">
              (<ng-container *ngIf="invite.organization">{{invite.organization}}</ng-container>
                <ng-container *ngIf="invite.organization && isCreator(invite)">, </ng-container>
                <ng-container *ngIf="isCreator(invite)">{{invite.email}}</ng-container>)
              </ng-container>
            </div>
            <button *ngIf="canUninvite(invite)" (click)="uninvite(invite)" class="btn btn-danger">
              Revoke Invitation
            </button>
            <small *ngIf="!canUninvite(invite)">
              You can't revoke this invitation, because someone invited this person with a stronger role.
            </small>
          </div>
        </ng-container>
      </div>

      <br/>
    </ng-container>
    -->

    <ng-container *ngIf="canInvite">
      <div style="text-align: right">
        <button class="btn btn-primary btn-lg" (click)="invite()">
          Invite Someone Else
        </button>
      </div>
    </ng-container>
  </div>
</div>
